// Envoi SMS en masse (Textra, Messages…) : numéros propres + séparateur attendu par l'appli du téléphone.
export const SEPARATEURS = [
  { cle: 'virgule_espace', label: 'virgule + espace  « 06…, 06… »  (Samsung, Textra)', sep: ', ' },
  { cle: 'virgule', label: 'virgule seule  « 06…,06… »', sep: ',' },
  { cle: 'point_virgule', label: 'point-virgule  « 06…;06… »  (Pixel, Xiaomi…)', sep: ';' },
  { cle: 'ligne', label: 'un numéro par ligne', sep: '\n' },
];
const CLE_STOCKAGE = 'raav_sms_separateur';

export const getSeparateur = () => SEPARATEURS.find(s => s.cle === localStorage.getItem(CLE_STOCKAGE)) || SEPARATEURS[0];
export const setSeparateur = (cle) => localStorage.setItem(CLE_STOCKAGE, cle);

// « 06 60 41 62 18 » / « +33 6 60… » / « 0033… » → 0660416218 ; étranger gardé en +XX…
export const normaliserTel = (brut) => {
  let t = String(brut || '').replace(/[^\d+]/g, '');
  if (!t) return '';
  if (t.startsWith('00')) t = `+${t.slice(2)}`;
  if (t.startsWith('+33') && t.length === 12) return `0${t.slice(3)}`;
  if (t.startsWith('33') && t.length === 11) return `0${t.slice(2)}`;
  if (t.startsWith('+')) return t;
  if (/^0[1-9]\d{8}$/.test(t)) return t;
  if (/^[1-9]\d{8}$/.test(t)) return `0${t}`;
  return t.length >= 9 ? t : '';
};

export const numerosUniques = (bruts) => [...new Set((bruts || []).map(normaliserTel).filter(Boolean))];

export const formaterPourSms = (bruts, sep = getSeparateur().sep) => numerosUniques(bruts).join(sep);

// Lien sms: pour ouvrir directement l'appli SMS du téléphone avec destinataires + texte (Android : séparateur , ou ;).
export const lienSms = (bruts, texte, sep = getSeparateur().sep) => {
  const nums = numerosUniques(bruts).join(sep === '\n' ? ',' : sep.trim());
  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  return `sms:${nums}${iOS ? '&' : '?'}body=${encodeURIComponent(texte || '')}`;
};

export const copier = async (texte) => {
  try { await navigator.clipboard.writeText(texte); return true; }
  catch { window.prompt('Copie manuelle :', texte); return false; }
};

// Alphabet GSM-7 (160 car./SMS) : é è à ù ç É passent, mais ô ê â î û ë œ « » – … et les emoji basculent tout le SMS en Unicode (70 car.).
const GSM7 = '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà';
const GSM7_EXT = '^{}\\[~]|€';
export const estGsm7 = (t) => [...(t || '')].every(c => GSM7.includes(c) || GSM7_EXT.includes(c));
export const nbSegmentsSms = (t) => {
  const s = t || '';
  if (!s.length) return 1;
  if (estGsm7(s)) { const l = [...s].reduce((n, c) => n + (GSM7_EXT.includes(c) ? 2 : 1), 0); return l <= 160 ? 1 : Math.ceil(l / 153); }
  const l = [...s].length;
  return l <= 70 ? 1 : Math.ceil(l / 67);
};
const TRANSLIT = { 'ô': 'o', 'ö': 'ö', 'ê': 'e', 'ë': 'e', 'â': 'a', 'î': 'i', 'ï': 'i', 'û': 'u', 'ü': 'ü', 'œ': 'oe', 'Ô': 'O', 'Ê': 'E', 'Â': 'A', 'Î': 'I', 'Û': 'U', 'Œ': 'OE', 'È': 'E', 'À': 'A', 'Ù': 'U', 'Ç': 'Ç', '«': '"', '»': '"', '–': '-', '—': '-', '…': '...', '’': '\'', '‘': '\'', '“': '"', '”': '"', '\u00a0': ' ' };
// Mode économique : garde les accents GSM-7, remplace les autres, retire les emoji → 160 caractères par SMS.
export const economiserSms = (t) => [...(t || '')].map(c => (GSM7.includes(c) || GSM7_EXT.includes(c)) ? c : (TRANSLIT[c] ?? (/\p{L}|\p{N}/u.test(c) ? c.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : ''))).join('').replace(/\s{2,}/g, ' ').trim();
